import { render, staticRenderFns } from "./form-wysiwyg.vue?vue&type=template&id=22edc8a2&"
import script from "./form-wysiwyg.vue?vue&type=script&lang=js&"
export * from "./form-wysiwyg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports